import { newDate } from "helpers/dateTools";
import { adminUnitsTypes } from "./types";

const {
  HANDLE_ADMIN_UNITS_INPUTS,
  RESTORE_INITIAL_STATE,
  GET_UNIT_DISPENSERS,
  ADD_UNIT_DISPENSER,
  EDIT_UNIT_DISPENSER,
} = adminUnitsTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  adminUnits: [],
  // CRM-2960: Dispensadores y equipo electrónico por unidad
  unitDispensers: {}, // { [unitId]: [...dispensers] }
};

export const adminUnitsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_ADMIN_UNITS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };

    // ── Dispensadores ──
    case GET_UNIT_DISPENSERS:
      return {
        ...state,
        unitDispensers: {
          ...state.unitDispensers,
          [payload.unitId]: payload.dispensers,
        },
      };
    case ADD_UNIT_DISPENSER:
      return {
        ...state,
        unitDispensers: {
          ...state.unitDispensers,
          [payload.unitId]: [
            ...(state.unitDispensers[payload.unitId] || []),
            payload.dispenser,
          ],
        },
      };
    case EDIT_UNIT_DISPENSER: {
      const currentDispensers = state.unitDispensers[payload.unitId] || [];
      return {
        ...state,
        unitDispensers: {
          ...state.unitDispensers,
          [payload.unitId]: currentDispensers.map((d) =>
            d.id === payload.dispenserId ? { ...d, ...payload.dispenser } : d
          ),
        },
      };
    }

    case RESTORE_INITIAL_STATE:
      return initialState;
    default:
      return state;
  }
};
